import { useLayoutEffect, useRef, type RefObject } from 'react';

/** The newest value of something an effect reads but must not restart for (a callback, a flag set once per mount). */
export function useLatest<T>(value: T): RefObject<T> {
  const ref = useRef(value);
  useLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
